import React from 'react';

const FeesTable = ({ fees, openEdit, handleDelete, onPrint, onExportPDF, onGeneratePDF, onFeePrint }) => (
  <div className="admins-table-scroll">
    <table className="admins-table students-table" id="fees-table">
      <thead>
        <tr>
          <th>Student</th>
          <th>Class</th>
          <th>Section</th>
          <th>Amount</th>
          <th>Due Date</th>
          <th>Description</th>
          <th>Created By</th>
          <th>Updated By</th>
          <th>Created Date</th>
          <th>Updated Date</th>
          <th className="actions-header">Actions</th>
        </tr>
      </thead>
      <tbody>
        {fees.map(fee => (
          <tr key={fee._id}>
            <td>{fee.student ? fee.student.name : 'N/A'}</td>
            <td>{fee.class}</td>
            <td>{fee.section}</td>
            <td>{fee.amount}</td>
            <td>{fee.dueDate && new Date(fee.dueDate).toLocaleDateString()}</td>
            <td>{fee.description}</td>
            <td>{fee.createdBy ? fee.createdBy.name : 'N/A'}</td>
            <td>{fee.updatedBy ? fee.updatedBy.name : 'N/A'}</td>
          <td>{fee.createdAt ? new Date(fee.createdAt).toLocaleString() : 'N/A'}</td>
          <td>{fee.updatedAt ? new Date(fee.updatedAt).toLocaleString() : 'N/A'}</td>
            <td>
              <div className="admin-actions">
                <button className="edit-btn" onClick={() => openEdit(fee)}>Edit</button>
                <button className="delete-btn" onClick={() => handleDelete(fee._id)}>Delete</button>
                <button className="action-btn print" title="Print" onClick={() => onFeePrint(fee)}>
                  <span role="img" aria-label="Print" style={{marginRight: '0.4em', display: 'inline'}}>🖨️</span> Print
                </button>
                <button className="action-btn generate-pdf" title="Generate PDF" onClick={() => onGeneratePDF(fee)}>
                  <span role="img" aria-label="Generate PDF" style={{marginRight: '0.4em', display: 'inline'}}>📋</span> Generate PDF
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default FeesTable; 